import { toDataURL } from 'qrcode'

/**
 * Renders an `otpauth://` TOTP enrollment URI to a scannable QR code as a
 * `data:image/png;base64,...` URI, entirely client-side via the bundled
 * `qrcode` package (no CDN/network fetch at runtime — required by the
 * self-only CSP). Used by the setup wizard's EnrollMFA step to display the
 * code returned by `setupClient.totpEnrollBegin()` alongside the manual-entry
 * secret, so an authenticator app can enroll either by scanning or by typing
 * the secret in by hand.
 *
 * Rejects (rather than silently rendering a blank/garbage code) when `uri`
 * is empty or otherwise unencodable, mirroring `qrcode`'s own promise
 * rejection for invalid input.
 */
export const renderTotpQr = async (uri: string): Promise<string> => {
  if (!uri) {
    throw new Error('renderTotpQr: otpauth URI must not be empty')
  }
  return toDataURL(uri, { type: 'image/png' })
}
